import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/moment3.webp")